import { render } from "./student-quiz.vue?vue&type=template&id=142d3423"
import script from "./student-quiz.vue?vue&type=script&lang=js"
export * from "./student-quiz.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__